export default __webpack_public_path__ + "static/864-191b58152d69e8491d341195fce52e7f.gif";